const ChannelListModel = function () {
    const name = 'ChannelList';
    return {
        name,
        state: {
            condition: {
                status:'',
                systemType:'3',
                appid:'',
                title:'',
                author:'',
                typeCode:'',
            },
            list: [],
            page: {
                pageSize: 10,
                current: 1,
                total: 0,
            }
        },
        selectors: (state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition: () => currentState.condition,
                getList: () => currentState.list,
                getPage: () => currentState.page,
            };
            return selectors;
        },
        api: {},
        actions: {
            changeCondition: (key, value) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_CHANNEL_LIST_CONDITION',
                    key,
                    value
                })
            },
            changeList: (list) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_CHANNEL_LIST_LIST',
                    list
                })
            },
            changePage: (page) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_CHANNEL_LIST_PAGE',
                    page
                })
            }
        },
        reducers: {
            condition: (state = ChannelListModel.state.condition, action) => {
                if (action.type === 'CHANGE_CHANNEL_LIST_CONDITION') {
                    const {key, value} = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page: (state = ChannelListModel.state.page, action) => {
                if (action.type === 'CHANGE_CHANNEL_LIST_PAGE') {
                    return Object.assign({}, state, action.page);
                }
                return state;
            },
            list: (state = ChannelListModel.state.list, action) => {
                if (action.type === 'CHANGE_CHANNEL_LIST_LIST') {
                    return [...action.list];
                };
                return state;
            }
        }
    }
}();

export default ChannelListModel;


// WEBPACK FOOTER //
// ./src/models/ChannelListModel.js